import _ from "lodash";

export function isValidationErrorResponse(err) {
    return err.response && err.response.status === 422;
}

export function requiredFile(files) {
    if (files.length === 0) {
        return "Must provide a file.";
    } else {
        return true;
    }
}

function newFieldRule(ruleFn, fieldName) {
    return (value) => {
        if (ruleFn(value)) {
            return true;
        } else {
            return `${fieldName} is required`;
        }
    };
}

function isArrayPresent(value) {
    return !_.isNil(value) && Array.isArray(value) && value.length > 0;
}

export function requiredArrayValueRule(fieldName) {
    return newFieldRule(isArrayPresent, fieldName);
}

function isSimpleValuePresent(value) {
    return !_.isNil(value);
}

function isSimpleValuePresentRule(fieldName) {
    return newFieldRule(isSimpleValuePresent, fieldName);
}

export function requiredSimpleValueRules(fieldName) {
    return [isSimpleValuePresentRule(fieldName)];
}

function isTextValuePresent(value) {
    return !_.isNil(value) && value.trim().length > 0;
}

function isTextValuePresentRule(fieldName) {
    return newFieldRule(isTextValuePresent, fieldName);
}

export function requiredTextValueRules(fieldName) {
    return [isTextValuePresentRule(fieldName)];
}

function isFileInputValuePresent(value) {
    if (!_.isNil(value)) {
        if (_.isArray(value)) {
            if (value.length > 0) {
                return true;
            }
        } else {
            return true;
        }
    }

    return false;
}

function isFilePresentRule(fieldName) {
    return newFieldRule(isFileInputValuePresent, fieldName);
}

export function requiredFileRules(fieldName) {
    return [isFilePresentRule(fieldName)];
}
